import styled from 'styled-components';

/**
 * Styles for CardCompareCheckbox molecule
 * Simple flexbox centering for checkbox alignment
 */
export const StyledCardCompareCheckbox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
